import ContactSectionOne from "./ContactUsSection/ContactSectionOne";

export default function ContactUs () {
    return (
        <div>
            <ContactSectionOne />
        </div>
    )
}